import TeImageList from './index.vue';


TeImageList.install = function(Vue) {
  Vue.component(TeImageList.name, TeImageList);
};

export default TeImageList;